import React, {memo} from 'react';
import MUIGrid from '@/components/MUI-Components/MUI-Grid';
import MUITypography from '@/components/MUI-Components/MUI-Typography';
import dynamic from 'next/dynamic';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
const DisplayImage = dynamic(import('@/components/Ui-components/display-image'));
import Box from '@mui/material/Box';

const AITechnology = (props: any) => {
    const {heading, subheading, technologyData} = props;
    return (
        <Box>
            <Box className="spectrum-header-wrapper">
                <MUITypography className="spectrum-heading">{heading}</MUITypography>
                <Box className="divder-wrapper">
                    <hr className="divider-line" />
                </Box>
                <Box className="sub-heading-box text-padding">
                    <MUITypography className="spectrum-sub-heading color-black">{subheading}</MUITypography>
                </Box>
            </Box>
            <MUIGrid container className="top-spacing">
                {technologyData?.map((item: any, index: number) => (
                    <MUIGrid item xs={12} sm={6} md={item.values.length > 12 ? 6 : 4} lg={item.values.length > 12 ? 6 : 4} key={index}>
                        <MUITypography variant="h6" className="tech-work-heading top-spacing">
                            {item.heading}
                        </MUITypography>
                        <Box className="benefit-section-card">
                            <MUIGrid container>
                                {item.values?.map((subitem: any, itemIndex: number) => (
                                    <MUIGrid
                                        item
                                        xs={6}
                                        sm={6}
                                        md={item.values.length > 12 ? 4 : 6}
                                        lg={item.values.length > 12 ? 4 : 6}
                                        key={itemIndex}
                                    >
                                        <List subheader={<li />}>
                                            <ListItem key={itemIndex} className="tech-list">
                                                <Box className="flag-icon">
                                                    <DisplayImage src={subitem.icon} alt={subitem.label} width={19} height={29} />
                                                </Box>

                                                <ListItemText className="list-item" primary={subitem.label} />
                                            </ListItem>
                                        </List>
                                    </MUIGrid>
                                ))}
                            </MUIGrid>
                        </Box>
                    </MUIGrid>
                ))}
            </MUIGrid>
        </Box>
    );
};

export default memo(AITechnology);
